<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <h2 class="layerTitle toCapitalize">{{ locale.mobility_destination_preset_place_setting }}</h2>
      <div class="editPlace">
        <div class="setPlace">
          <div class="isRequired">
            <div class="innerTitle setLabel">{{ locale.search_place }}</div>
          </div>
          <div class="searchPlace">
            <div class="inputBox">
              <input
                type="text"
                class="input"
                ref="placeInput"
                v-model="content.name"
                @keypress.enter="getPlace"
                @focus="displayPlaces = true">
              <div
                v-if="places && displayPlaces"
                class="placeList">
                <button type="button" class="btnClose"></button>
                <div
                  v-for="(place, index) in places"
                  :key="index"
                  class="placeItem"
                  :ref="`place_item_${index}`"
                  :class="{selected: place.selected}"
                  @click.stop="selectPlace(place)">
                  <div class="name">{{ place.displayName.text }}</div>
                  <div class="address">{{ place.shortFormattedAddress || place.formattedAddress }}</div>
                </div>
              </div>
            </div>
            <button type="button" class="btn" @click.stop="getPlace">{{ locale.search_place }}</button>
          </div>
          <div class="mapBox">
            <div v-if="!(content.placeInfo && content.placeInfo.location)" class="noPlace">{{ locale.search_place_nodata }}</div>
            <div id="placeMap"></div>
          </div>
        </div>
        <div class="setBanner">
          <div class="mb15">
            <div class="isRequired">
              <div class="innerTitle setLabel">{{ locale.place_name }}</div>
            </div>
            <div class="translation">
              <input class="input" row="5" v-model="content.title[lang.default]" @focusout="setDefaultVal('title')" />
              <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('title')">
                <span class="blind">{{locale.language_specific_set}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
              </button>
            </div>
          </div>
          <div class="mb15">
            <div class="innerTitle setLabel">{{ locale.place_description }}</div>
            <div class="translation">
              <textarea class="input" row="5" v-model="content.description[lang.default]" @focusout="setDefaultVal('description')"></textarea>
              <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen('description')">
                <span class="blind">{{locale.language_specific_set}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
              </button>
            </div>
          </div>
          <div class="mb15">
            <div class="innerTitle setLabel">{{locale.image}}</div>
            <div v-if="content.img" class="bgThumb">
              <img :src="content.img" alt="" />
              <button type="button" class="delThumb" @click="deleteImage"><img src="~@/assets/img/ico_close.svg" alt=""></button>
            </div>
            <div v-else><label class="btn btnFull btnWhite toUppercase">{{locale.upload}}<input type="file" @change="uploadImage($event)"></label></div>
          </div>
          <div class="btns">
            <button
              type="button"
              class="btn btnFull btnPrimary toCapitalize"
              :disabled="isDisabled"
              @click="apply">
              {{locale.apply}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :langValue="langValue"
      :title="locale.language_specific_set"
      @close="onLangValueClose" />
    <!-- //언어별 세팅 -->
  </div>
</template>

<script>
import LangValue from '@/components/Util/LangValue.vue'
import UTIL from '@/common/util'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import { Loader } from "@googlemaps/js-api-loader"

export default {
  name: 'MobilityPresetItem',
  props: [
    'locale',
    'presetData'
  ],
  components: {
    LangValue
  },
  computed: {
    lang () {
      const settingData = this.$store.getters['setting/getData']
      return settingData.lang
    },
    isDisabled () {
      const defaultLang = this.lang.default
      const content = this.content
      const name = content && content.name
      const title = content && content.title && content.title[defaultLang]
      return !(name && title)
    }
  },
  created () {
    if (this.presetData) {
      this.content = this._.cloneDeep(this.presetData)
    }
  },
  mounted () {
    this.$nextTick(async () => {
      if (this.$refs.placeInput) {
        this.$refs.placeInput.focus()
      }
      await this.loadMap()
      this.initMap()
    })
  },
  data () {
    return {
      content: {
        name: '',
        title: {},
        description: {},
        img: ''
      },
      langTarget: '',
      langValueLayer: false,
      langValue: {},
      displayPlaces: false,
      places: null,
      map: null,
      mapMarker: null
    }
  },
  methods: {
    async loadMap () {
      const loader = new Loader({
        apiKey: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
        version: "weekly"
      })
      await loader.load()
      return loader
    },
    async initMap () {
      const { Map } = await google.maps.importLibrary('maps')
      const { event } = await google.maps.importLibrary('core')
      const { AdvancedMarkerElement } = await google.maps.importLibrary('marker')
      const mapId = UNIQUE.mid()
      const location = this.content.placeInfo && this.content.placeInfo.location
      let map = new Map(document.getElementById('placeMap'), {
        zoom: 16,
        center: location,
        mapId: mapId,
        mapTypeControl: false,
        rotateControl: false
      })
      this.map = map
      
      this.mapMarker = new AdvancedMarkerElement({
        map: map,
        position: location
      })
      google.maps.event.addListener(map, 'center_changed', () => {
        const location = {
          lat: map.center.lat(),
          lng: map.center.lng()
        }
        this.mapMarker.position = location
        if (this.content.placeInfo) {
          this.content.placeInfo.location = location
        }
      })
    },
    getPlace () {
      const name = this.content.name
      if (name) {
        this.$store.commit('onLoading', true)
        this.$store.dispatch('features/getPlace', name).then((res) => {
          if (res && res.places) {
            this.places = res.places.map(x => {
              return {
                ...x,
                selected: false
              }
            })
            this.displayPlaces = true
          }
          this.$store.commit('onLoading', false)
        })
      } else {
        alert('이름을 입력한 후 장소를 검색해주세요.')
      }
    },
    // 검색된 장소 선택
    async selectPlace (item) {
      const location = {
        lat: item.location.latitude,
        lng: item.location.longitude
      }
      this.content = {
        ...this.content,
        name: item.displayName.text,
        placeInfo: {
          ...item,
          location: location
        }
      }
      this.places = this.places.map(x => {
        return {
          ...x,
          selected: x.id === item.id
        }
      })
      this.displayPlaces = false
      this.map.setCenter(location)
      this.mapMarker.position = location
    },
    setDefaultVal (target) {
      const defaultLang = this.lang.default
      const fillLangs = UTIL.fillLangs(this.content[target], this.content[target][defaultLang])
      this.content[target] = fillLangs
    },
    onLangValueOpen (target) {
      this.langTarget = target
      this.langValueLayer = true
      this.langValue = this.content[target]
      this.setDefaultVal()
    },
    onLangValueClose () {
      const target = this.langTarget
      this.langValueLayer = false
      this.content[target] = this.langValue
      this.langValue = {}
    },
    uploadImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      console.log('upload')
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.content.img = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteImage () {
      this.content.img = ''
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel_preset_setting)) {
        this.$emit('cancel')
      }
    },
    apply () {
      const data = this.content
      if (window.confirm(this.locale.confirm_apply_preset_setting)) {
        this.$emit('apply', data)
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 1200px;
  }
}
.isRequired {
  .innerTitle:before {
    content: "*";
    color: $color-red;
    line-height: 1;
  }
  .setLabel.innerTitle {
    padding-left: 1.5em;
    &:before {
      text-indent: 0.7em;
    }
  }
}
.editPlace {
  display: flex;
  margin-bottom: 30px;
  .setBanner {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: 30px;
    .btns {
      margin-top: auto;
    }
  }
  .setPlace {
    width: 840px;
  }
  .mapBox {
    position: relative;
    height: 520px;
    margin-top: 15px;
    border: 1px solid $color-lgrey2;
  }
  .noPlace {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 24px;
    color: $color-lgrey;
    background-color: $color-white;
    z-index: 9;
  }
  #placeMap {
    position: relative;
    height: 100%;
    background-color: $color-white;
  }
}
.searchPlace {
  display: flex;
  align-items: center;
  width: 100%;
  .inputBox {
    position: relative;
    flex: 1;
    margin-right: 4px;
  }
  .placeList {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 300px;
    border: 1px solid $color-lgrey;
    border-top: none;
    background-color: $color-white;
    overflow: auto;
    z-index: 99;
    .btnClose {
      width: 32px;
      height: 32px;
      background: url('~@/assets/img/ico_close_black.svg') 50% 50% / 16px no-repeat;
    }
    .placeItem {
      padding: 8px 15px;
      cursor: pointer;
      &:hover,
      &.selected {
        color: $color-primary;
      }
      & + .placeItem {
        border-top: 1px solid $color-lgrey2;
      }
    }
    .name {
      font-size: 14px;
    }
    .address {
      color: $color-lgrey;
    }
  }
}
.placeAddress {
  font-size: 12px;
}
.bgThumb {
  position: relative;
  .uploadImg {
    display: block;
    padding: 60px 0;
    color: $color-grey;
    font-size: $f-z-default;
    background-color: $bg-default;
    cursor: pointer;
  }
  .hasImg {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 0.5em 0;
    font-size: 0.85em;
    color: $color-dgrey;
    opacity: 0;
    box-shadow: 0 0 3px rgba(0,0,0,0.2);
    z-index: -1;
    transition: all 0.3s;
  }
  &:hover .hasImg {
    display: block;
    font-size: $f-z-default;
    opacity: 0.7;
    z-index: 1;
  }
}
</style>
